module.exports = __webpack_public_path__ + "static/img/obj5.9ac438fe.png";